import linkify from 'vue-linkify'

export default () => linkify
